const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMartyToggleOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "13.41mm",
    height: "7.41mm",
    viewBox: "0 0 38 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "Track",
    d: "M10.5,0h17c5.8,0,10.5,4.7,10.5,10.5h0c0,5.8-4.7,10.5-10.5,10.5H10.5C4.7,21,0,16.3,0,10.5H0C0,4.7,4.7,0,10.5,0Z",
    style: {
      fill: "#d1d3d4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Handle"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,21C4.71,21,0,16.29,0,10.5S4.71,0,10.5,0s10.5,4.71,10.5,10.5-4.71,10.5-10.5,10.5ZM10.5,2C5.81,2,2,5.81,2,10.5s3.81,8.5,8.5,8.5,8.5-3.81,8.5-8.5S15.19,2,10.5,2Z",
    style: {
      fill: "#a7a9ac"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMartyToggleOff);
export default __webpack_public_path__ + "static/media/marty_toggle_off.559fcaf1adb90df334ff7f2e62a7042d.svg";
export { ForwardRef as ReactComponent };